// Module
var code = "<a href=\"#\"> <i class=\"fa transition fa-play run-query-icon\"></i> Run query </a>";
// Exports
export default code;